<div class="notification-box" [ngClass]="type">
  <span class="icon">
    <ng-container *ngIf="type === 'success'">
      ✔️
    </ng-container>
    <ng-container *ngIf="type === 'error'">
      ❌
    </ng-container>
  </span>
  <span class="message">{{ message | translate }}</span>
  <button class="close-btn" (click)="close()">×</button>
</div>
